import { render, staticRenderFns } from "./Tele2Footer.vue?vue&type=template&id=17dbcfdc&scoped=true&"
import script from "./Tele2Footer.vue?vue&type=script&lang=js&"
export * from "./Tele2Footer.vue?vue&type=script&lang=js&"
import style0 from "./Tele2Footer.vue?vue&type=style&index=0&id=17dbcfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dbcfdc",
  null
  
)

export default component.exports